export default __webpack_public_path__ + "static/media/download (5).fc9d021c.svg";